<div id="loader-overlay">
  <div class="loader">
  </div>
</div>
<div class="main-login-container">
  <div role="main" class="logincontainer min-height-100vh" cols="12" rowHeight="100%">
    <div colspan="5" class="mat-grid-tile-professional1 bgc-fasb-blue font-white">
      <div class="height-4rem">
        <img alt="logo" [src]="logo" class="icon-fasb-logo">
      </div>
      <div class="login-basic1">
        <div class="basic-professional-heading font-white">
          <h2 class="h2-login-basicView">{{ViewHeader}}</h2>
          <article class="h2-login-basicViewDesc mt-1rem-imp ms-1" [innerHTML]="ViewConent"></article>
        </div>
      </div>
    </div>
    <div class="mat-grid-tile-basic" colspan="7">
      <div class="login-basic2">
        <div>
          <span class="basic-view">{{rightPanelTitle1}}</span><br />
          <span class="basic-view">{{rightPanelTitle2}}</span>
          <p class="p-16-basic mt-3">
            {{rightPanelDescription}}
            <a class="hyperlink-basic cursor-pointer" (click)="showTC(true)">{{Termandcondition}}</a>.
          </p>
        </div>
        <div class="recaptcha" *ngIf="siteKey">
          <form [formGroup]="aFormGroup">
            <ngx-recaptcha2 #captchaElem
                            id="recaptchabasic"
                            siteKey={{siteKey}}
                            (success)="resolved($event)"
                            (error)="errorrecap()"
                            (expire)="errorrecap()"
                            formControlName="recaptcha">
            </ngx-recaptcha2>
          </form>
        </div>
        <div class="basic-access-btn">
          <button class="btn-secondary-disabled-basic btn-l-basic" [title]="accessButtonTitle" id="btnBasicView" disabled (click)="accessBasicView()">
            {{accessBasicViewButton}}
          </button>
        </div>
        <div class="usageText">
          <span class="p-16-basic">{{usageText}}</span>
        </div>
        <div *ngIf="showAcademicView">
          <p class="academic-view">{{AcademicViewHeader}}</p>
          <div class="p-16-basic" id="academicviewcontent" [innerHTML]="AcademicViewContent"></div>
        </div>
        <div class="usageText1">
          <span class="p-16-basic">
            {{additionalInfo}} <a class="hyperlink-basic cursor-pointer" tabindex="0" (click)="contactSupportOverlay()">
              {{contactFASBSupport}}
            </a>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

